



















































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { AloNewsletter, getDefaultAloNewsletter } from '@/models/alo/AloNewsletter'
import { VuetifyConfirmObject } from '@/plugins/confirm/types'
import {DashboardAdmin} from '@/router/pages'
import cloneDeep from 'clone-deep'
import axios from 'axios'
import FileDownload from 'js-file-download'

@Component({
  name: 'GestionNewsletter'  
})
export default class GestionNewsletter extends Vue {
  private loading = false
  private showError = false  
  private showNew = false
  private newNewsletter = getDefaultAloNewsletter()
  private defaultHeaderHeight = 90  
  private actioning = false
  mounted() {
    this.defaultHeaderHeight = 5
  }

  get tableauHeight(){
    //@ts-ignore
    return this.$store.myGetters.contentHeight - ((this.$refs?.header?.clientHeight+this.defaultHeaderHeight)??this.defaultHeaderHeight)
  }

  private get isAllSelected() {
    return this.newsletterList.every(p => p.selected)
  }

  private get someSelected() {
    return this.newsletterList.some(p => p.selected)
  }

  private headers = [
    { text: '', value: 'selected', width:30,sortable:false, filterable:false },
    { text: 'ID', value: 'id', width:70 },    
    { text: 'Date inscription', value: 'nwlDatadd', width:160 },
    { text: 'Activé', value: 'nwlDisabled', width:160 },
    { text: 'Titre', value: 'libelle' },
    { text: '', value:'actions', width:90, sortable:false,filterable:false}
  ]

  private get newsletterList() {
    return this.$store.myGetters.newsletterList
  }

  private get search(){
    return this.$store.myGetters.searchNewsletter
  }
  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_NEWSLETTER(value)
  }

  private get sortDesc(){
    return this.$store.myGetters.sortNewsletterDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_NEWSLETTER_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortNewsletterBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_NEWSLETTER_BY(value)
  }
  

  private get activityDic(){
    return this.$store.myGetters.activityDic
  }

    
  created() {
    this.$store.myActions.ADM_ACTIVITY_ENSURE();
    this.loading = true    
    this.$store.myActions.ADM_NEWSLETTER_ENSURE().finally(() => {
      this.loading = false
    })
  }


  deleteNewsletter(newsletter:AloNewsletter) {
     if(newsletter.id != 0) {             
       this.$confirm(`Voulez vous vraiment supprimer la newsletter "${newsletter.libelle}" ?`,{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          this.$store.myActions.ADM_NEWSLETTER_DELETE_REQUEST(newsletter.id)
        } 
      })          
    } 
  }

  toggleActivation(newsletter:AloNewsletter){
     if(newsletter.id != 0) {      
       this.$confirm(`Voulez vous vraiment ${newsletter.nwlDisabled?'activer':'désactiver'} l'inscription à la newsletter de "${newsletter.libelle}" ?`,{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          const modified = cloneDeep(newsletter)
          modified.nwlDisabled = !modified.nwlDisabled
          this.$store.myActions.ADM_NEWSLETTER_SAVE_REQUEST(modified)
        } 
      })          
    } 
  }

  exportNewsletter(){
    this.actioning = true
     axios({
      url: '/webapi/Newsletter/execute',
      method: 'PUT',
      data:{
        nwlIds:this.newsletterList.filter(c => c.selected).map(c => c.id),
        action:'export'
      },
      responseType: 'blob', // Important
    }).then((response) => {        
        FileDownload(response.data, 'Newsletter.xlsx');
    }).finally(()=>{
      this.actioning = false
    });    
  }  

  markAsActivated(activated:boolean){
    this.actioning = true
    this.$store.myActions.ADM_NEWSLETTER_ACTION_ON_SELECTION_REQUEST({
        nwlIds:this.newsletterList.filter(c => c.selected).map(c => c.id),
        action:activated?'activate':'desactivate'
      }).finally(()=>{
      this.actioning = false
    });    
  } 

  toogleSelection(item:AloNewsletter) {
    this.$store.myActions.ADM_NEWSLETTER_SET_SELECTION({selected:!item.selected,ids:[item.id]})
  }

  toogleAllSelection() {
    this.$store.myActions.ADM_NEWSLETTER_SET_SELECTION({selected:!this.isAllSelected,ids:this.newsletterList.map(p => p.id)})    
  }

  addNewsletter(){
    this.showNew = true      
    this.newNewsletter = getDefaultAloNewsletter()
    this.newNewsletter.nwlDisabled = false
  }

  save(){
    this.$store.myActions.ADM_NEWSLETTER_SAVE_REQUEST(this.newNewsletter).then((newsletter)=>{
      this.showNew = false      
    })    
  }

  get arianeItems() {
    return  [
        DashboardAdmin,
        {
          text: 'Activités',
          disabled: true,  
          to: {name:'AdminNewsletter'},        
          exact:true
        }
      ]      
  } 
 
}
